import { render } from "./PermissionsPage.vue?vue&type=template&id=02d108f8&ts=true"
import script from "./PermissionsPage.vue?vue&type=script&lang=ts"
export * from "./PermissionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__